import withSearch from './withSearch'
import Select from '.'

const SelectWithSearch = withSearch(Select)

export default SelectWithSearch
